<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div v-if="!inline" class="modal fade" id="validate-address-modal" tabindex="-1" role="dialog"
         aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
              aria-hidden="true">&times;</span></button>
            <h4 class="modal-title" id="myModalLabel">Validate Address</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">The address was found with <span v-html="confidenceDisplay"></span> confidence:</div>
            </div>
            <div class="row">
              <div class="col-md-1">
                <button type="button" class="btn btn-link" data-toggle="tooltip" title="Open in Bing Maps"
                        @click="openMap()"><span class="glyphicons glyphicons-map-marker"></span></button>
              </div>
              <div class="col-md-11">
                <strong v-html="formattedAddress"></strong>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" @click="close()">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="inline && show" class="panel panel-info">
      <div class="panel-heading">
        <h4 class="panel-title">Address Validation</h4>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-12">The address was found with <span v-html="confidenceDisplay"></span> confidence:</div>
        </div>
        <div class="row">
          <div class="col-md-1">
            <button type="button" class="btn btn-link" data-toggle="tooltip" title="Open in Bing Maps"
                    @click="openMap()"><span class="glyphicons glyphicons-map-marker"></span></button>
          </div>
          <div class="col-md-11">
            <strong v-html="formattedAddress"></strong>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button type="button" class="btn btn-default pull-right" @click="close()">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import AddressService from '../endpoints/admin/AddressService'
import FormValidationMixIn from './FormValidationMixIn'

export default {
  name: 'ValidateAddressModal',
  mixins: [FormValidationMixIn],
  props: {
    address: {
      type: Object,
      required: true
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      validatedAddress: {},
      show: false
    }
  },
  computed: {
    formattedAddress () {
      let compiledAddress = []

      if (this.validatedAddress.line1) {
        compiledAddress.push(this.validatedAddress.line1)
      }

      if (this.validatedAddress.line2) {
        if (compiledAddress.length > 0) {
          compiledAddress.push('<br>')
        }

        compiledAddress.push(this.validatedAddress.line2)
      }

      compiledAddress.push('<br>')
      compiledAddress.push(`${this.validatedAddress.city}, `)
      compiledAddress.push(`${this.validatedAddress.state} `)
      compiledAddress.push(this.validatedAddress.postalCode)
      return compiledAddress.join('')
    },
    buildLargeAddressLink () {
      const addressOneLine = this.formattedAddress.replaceAll('<br>', ', ')
      return `https://www.bing.com/maps?where1=${addressOneLine}&sty=r&lvl=11&FORM=MBEDLD`
    },
    confidenceDisplay () {
      let html = ''
      if (this.validatedAddress.confidence) {
        if (this.validatedAddress.confidence === 'High') {
          html = `<strong>${this.validatedAddress.confidence}</strong>`
        } else {
          html = `<strong class="text-danger">${this.validatedAddress.confidence}</strong>`
        }
      }
      return html
    }
  },
  methods: {
    open () {
      $.blockUI({message: '<h3>Validating address...</h3>'})
      AddressService.validateAddress(this.convertToApiAddress(this.address))
        .then(response => {
          this.validatedAddress = response.data
          if (this.inline) {
            this.show = true
          } else {
            $('#validate-address-modal').modal('show')
          }
          $.unblockUI()
        })
        .catch(error => {
          if (error.response.data.globalErrors) {
            this.onError(error.response.data.globalErrors[0])
          } else {
            console.log(error.stack)
            this.onError(error.message)
          }
          $.unblockUI()
        })
    },
    close () {
      if (this.inline) {
        this.show = false
      } else {
        $('#validate-address-modal').modal('hide')
      }
      this.validatedAddress = {}
    },
    emitUpdate () {
      // This code is not called currently
      this.$emit('update-address', this.convertToMdbAddress(this.validatedAddress))
      this.close()
    },
    openMap () {
      window.open(this.buildLargeAddressLink, '_blank')
    },
    convertToApiAddress (address) {
      return {
        line1: address.address1,
        line2: address.address2,
        city: address.city,
        state: address.state,
        postalCode: address.postalCode
      }
    },
    convertToMdbAddress (address) {
      return {
        address1: address.line1,
        address2: address.line2,
        city: address.city,
        state: address.state,
        postalCode: address.postalCode
      }
    }
  }
}
</script>
